<template>
<div id="video" class="video">
    <youtube :video-id="videoId" :player-vars="options" @ready="ready" @playing="playing" :mute="true"></youtube>
    <div class="video__overlay" :class="{'video__overlay--hidden': isPlaying}">
        <img alt="Video image" :src="startImage" v-if="!isPaused">
        <img alt="Video image" :src="endImage" v-if="isPaused">
    </div>
</div>
</template>
<script>
import VueYouTubeEmbed from 'vue-youtube-embed';
export default {
    props: ['videoId', 'startImage', 'endImage'],
    data: () => ({
        isPlaying: false,
        isPaused: false,
        options: {
            controls: 0,
            autoplay: 1,
            modestBranding: 1,
            rel: 0,
            loop: 0,
            mute: true,
            playsinline: 1,
            suggestedQuality: 'highres'
        }
    }),
    beforeDestroy() {
        if (this.player) { 
            this.player.destroy();
        }
        if (this.pauseVideoTimeout) { 
            clearTimeout(this.pauseVideoTimeout);
        }
        if (this.fadeOutTimeout) { 
            clearTimeout(this.fadeOutTimeout);
        }
    },
    methods: {
        pause() {
            if (this.pauseVideoTimeout) { 
                clearTimeout(this.pauseVideoTimeout);
            }
            this.player.pauseVideo();
            this.player.destroy();
        },
        hideVideo() {
            this.isPlaying = false;
            this.isPaused = true;
            if (this.fadeOutTimeout) {
                clearTimeout(this.fadeOutTimeout);
            }
        },
        ready(player) { 
            this.player = player;
        },
        playing(player) {
            const remainingTime = player.getDuration() - player.getCurrentTime();
            // const quality = player.getAvailableQualityLevels()[0];
            player.setPlaybackQuality('highres');
            if (this.pauseVideoTimeout) {
                clearTimeout(this.pauseVideoTimeout);
            }
            if (this.fadeOutTimeout) {
                clearTimeout(this.fadeOutTimeout);
            }
            this.isPlaying = true;
            this.pauseVideoTimeout = setTimeout(this.pause, (remainingTime - 0.1) * 1000);
            this.fadeOutTimeout = setTimeout(this.hideVideo, (remainingTime - 0.5) * 1000);
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/vendor/backgroundVideo.vue